(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name acarsMessages.factory:AcarsMessagesFactory
     *
     * @description
     *
     */
    angular
    	.module('acarsMessages')
        .factory('AcarsMessagesFactory', AcarsMessagesFactory);
    
    function AcarsMessagesFactory() {

        function SearchCriteriaDTO(){
            this.fromDate = null;
            this.fromTime = null;
            this.toDate = null;
            this.toTime = null;
            this.flightNo = null;
            this.depature = null;
            this.arrival = null;
            this.status = null;
            this.pageSize = null;
            this.startPosition = null;
        }
        
        function MessageDTO(){
        	this.flightNo = null;
        	this.origin = null;
        	this.destination = null;
        	this.msgDate = null;
        	this.msgType = null;
        	this.msgContent = null;
        	this.status = null;
        }
        
        
        function GetSearchRequest(searchParam) {
            var searchRequest = new SearchCriteriaDTO();
			searchRequest.flightNo = searchParam.flightNumber;
			searchRequest.depature = searchParam.origin == "" || searchParam.origin == " " ? "" : searchParam.origin.airPortCode;
			searchRequest.arrival = searchParam.destination == "" || searchParam.destination == " " ? "" : searchParam.destination.airPortCode;
			searchRequest.fromDate = searchParam.fromDate;
			searchRequest.fromTime = searchParam.fromTime;
			searchRequest.toDate = searchParam.toDate;
			searchRequest.toTime = searchParam.toTime;
			searchRequest.status = !searchParam.messageStatus || searchParam.messageStatus == "" ? null : searchParam.messageStatus.statusCode;
			searchRequest.pageSize = searchParam.pageSize;
			searchRequest.startPosition = searchParam.startPosition;
			return searchRequest;
        }
        
        function GetFormattedMessages(messagesData) {
        	angular.forEach(messagesData.acarsDTOs, function(message) {
        		//remove unicode \u0002 and \u0002
        		message.msgContent = message.msgContent.replace(/\u0002/g,"").replace(/\u0003/g,"");
        		message.status = message.status == "YES" ? "Processed" : "Pending";
        	});
        	return messagesData;
        }
        
        return {
        	getSearchRequest: GetSearchRequest,
        	getFormattedMessages: GetFormattedMessages
        }
    }
})();
